export default (state = {}, action) => {
  switch (action.type) {
    case 'RECOMMENDATION_ANALYTICS_REQUEST':
    case 'RECOMMENDATION_ANALYTICS_RESPONSE':
      if (action.userId) {
        return { ...state, [action.userId]: action.payload };
      }
      return { ...state, team: action.payload };
    default:
      return state;
  }
};
